const parseUrl = () => {
  const currentUrl = window.location.href;
  return currentUrl.includes('cavem') ? 'cavem' : 'analytics';
};
export default parseUrl;
